import { useCallback, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { ADDON_META, ADDON_STATUS } from "@/lib/addons";
import { fmtDay } from "@/lib/daytime";

function Req({ a, onChange }) {
  const decide = async (approve) => {
    const body = { approve };
    if (approve) { const p = window.prompt("Confirm price ($)", a.price); if (p === null) return; body.price = Number(p); }
    else { const n = window.prompt("Reason / suggested other time (sent to parent)", ""); if (n === null) return; body.note = n; }
    try { await api.post(`/addons/admin/${a.id}/decide`, body); toast.success(approve ? "Confirmed — parent notified" : "Declined — parent notified"); onChange(); } catch (e) { toast.error(apiErr(e)); }
  };
  const cancel = async () => { if (!window.confirm("Cancel this service?")) return; try { await api.post(`/addons/admin/${a.id}/cancel`); onChange(); } catch (e) { toast.error(apiErr(e)); } };
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-3" data-testid={`addon-admin-row-${a.id}`}>
      <div className="flex flex-wrap justify-between gap-2">
        <div>
          <p className="font-bold text-navy">{ADDON_META[a.service].name} · {fmtDay(a.date)} {a.start}{a.end ? `–${a.end}` : ""}
            <span className={`ml-2 text-[10px] uppercase rounded-full px-2 py-0.5 ${ADDON_STATUS[a.status]}`}>{a.status.replace("_", " ")}</span>
            {a.outside_availability && <span className="ml-1 text-[10px] bg-coral text-white rounded-full px-2 py-0.5">OUTSIDE AVAILABILITY</span>}
            {a.status !== "requested" && a.status !== "cancelled" && !a.paid && <span className="ml-1 text-[10px] bg-amber-200 rounded-full px-2 py-0.5">UNPAID</span>}</p>
          <p className="text-xs text-slate-500">{a.parent_name} · {a.parent_phone} · {a.child_names.join(", ")} · ${a.price}{a.quote?.discount ? ` (member −$${a.quote.discount})` : ""}</p>
          {(a.pickup_location || a.destination) && <p className="text-xs text-slate-500">{a.pickup_location} → {a.destination}{a.receiving_adult ? ` · receiver ${a.receiving_adult}` : ""}</p>}
          {a.unavailable_reason && <p className="text-xs text-coral">{a.unavailable_reason}</p>}
          {a.notes && <p className="text-xs text-slate-400">Note: {a.notes}</p>}
        </div>
        <div className="flex gap-1.5 items-start">
          {a.status === "requested" && <><Button size="sm" className="rounded-full bg-emerald-600" onClick={() => decide(true)} data-testid={`addon-confirm-${a.id}`}>Confirm</Button>
            <Button size="sm" variant="outline" className="rounded-full text-coral" onClick={() => decide(false)} data-testid={`addon-decline-${a.id}`}>Decline</Button></>}
          {a.status === "confirmed" && <Button size="sm" variant="outline" className="rounded-full text-coral" onClick={cancel} data-testid={`addon-admin-cancel-${a.id}`}>Cancel</Button>}
        </div>
      </div>
    </div>
  );
}

export function AddonsAdmin() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("requested");
  const load = useCallback(() => { api.get(`/addons/admin/list?status=${filter}`).then((r) => setRows(r.data)).catch((e) => toast.error(apiErr(e))); }, [filter]);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-2 mt-3" data-testid="addons-admin">
      <div className="flex flex-wrap gap-1.5">{[["requested", "Requests"], ["confirmed", "Confirmed"], ["in_progress", "In progress"], ["", "All upcoming"]].map(([k, l]) => (
        <button key={k || "all"} onClick={() => setFilter(k)} className={`px-3 py-1.5 rounded-full text-sm border ${filter === k ? "bg-navy text-white" : "border-slate-200"}`} data-testid={`addons-filter-${k || "all"}`}>{l}</button>))}</div>
      {rows.map((a) => <Req key={a.id} a={a} onChange={load} />)}
      {rows.length === 0 && <p className="text-sm text-slate-400">Nothing here.</p>}
    </div>
  );
}
